exports.hardRefreshRoot = function () {
  window.location = "/";
};
